var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCometCrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32.00 32.00",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff",
    strokeWidth: 0.512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.44800000000000006
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 22v2h-32v-24h2v22zm-2-19.5v6.8.002c0 .275-.223.498-.498.498-.142 0-.271-.06-.361-.156l-1.89-1.89-9.89 9.887c-.09.097-.218.157-.36.157s-.27-.06-.36-.157l-3.64-3.641-6.5 6.5-3-3 9.14-9.141c.09-.097.218-.157.36-.157s.27.06.36.157l3.64 3.641 7.25-7.25-1.89-1.89c-.096-.091-.156-.219-.156-.362 0-.275.223-.498.498-.498h.002 6.8.02c.265 0 .48.215.48.48v.021-.001z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 22v2h-32v-24h2v22zm-2-19.5v6.8.002c0 .275-.223.498-.498.498-.142 0-.271-.06-.361-.156l-1.89-1.89-9.89 9.887c-.09.097-.218.157-.36.157s-.27-.06-.36-.157l-3.64-3.641-6.5 6.5-3-3 9.14-9.141c.09-.097.218-.157.36-.157s.27.06.36.157l3.64 3.641 7.25-7.25-1.89-1.89c-.096-.091-.156-.219-.156-.362 0-.275.223-.498.498-.498h.002 6.8.02c.265 0 .48.215.48.48v.021-.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCometCrash);
export default __webpack_public_path__ + "static/media/comet-crash.ca99deb33dbf49cfb5594de731300baf.svg";
export { ForwardRef as ReactComponent };